import {
    parseISO,
    format,
    subDays,
    formatISO,
    startOfMonth,
    endOfMonth,
} from 'date-fns';


export function formatDateISO(dateISO, dateFormat = 'Ppp') {
    if (dateISO === 'NA') return 'NA';
    try {
        return format(parseISO(dateISO), dateFormat);
    } catch (e) {
        return 'Error parsing date string';
    }
}


export function formatDateISOWithSeconds(dateISO) {
    if (dateISO === 'NA') return 'NA';
    try {
        return format(parseISO(dateISO), 'Ppp');
    } catch (e) {
        return 'Error parsing date string';
    }
}

export function subtractDaysFromCurrentDateToISO(daysToSubtract) {
    const todaysDate = new Date();
    return formatISO(subDays(todaysDate, daysToSubtract));
}

export function getFirstAndLastDayOfMonthISOStrings(jsDateObj) {
    return {
        startDate: formatISO(startOfMonth(jsDateObj)),
        endDate: formatISO(endOfMonth(jsDateObj)),
    };
}
